import { render, staticRenderFns } from "./uploadLinksChat.vue?vue&type=template&id=f0e3841e&scoped=true&"
import script from "./uploadLinksChat.vue?vue&type=script&lang=js&"
export * from "./uploadLinksChat.vue?vue&type=script&lang=js&"
import style0 from "./uploadLinksChat.vue?vue&type=style&index=0&id=f0e3841e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e3841e",
  null
  
)

export default component.exports